/** First-party files and prepared variants must not take another proxy hop. */
export function partsImageSource(src: string, proxyBase: string): string {
  if (!src || src.startsWith("/") || src.startsWith("data:") || src.includes("/cdn-img-proxy")) return src;
  try {
    const url = new URL(src);
    const hosted = url.hostname === "www.myrvpart.com" || url.hostname === "myrvpart.com" ||
      (url.hostname === "cpkvmigljcrjxctoixoq.supabase.co" &&
        (url.pathname.startsWith("/storage/v1/object/public/") || url.pathname.startsWith("/storage/v1/render/image/public/")));
    if (hosted) return src;
    const encoded = btoa(unescape(encodeURIComponent(src)))
      .replace(/\+/g, "-").replace(/\//g, "_").replace(/=+$/, "");
    return `${proxyBase}?u=${encoded}`;
  } catch {
    return src;
  }
}